import ScrollMagic from 'scrollmagic'

const pathname = location.pathname;

if (pathname === "/") {
    let controller = new ScrollMagic.Controller();
    class ScrollFade {
        constructor() {
            this.ANIMATION_CLASS = 'is-fire';

            let $section = document.querySelectorAll('.js-scroll:not(.is-fire)');
            if ($section.length === null) {
                return;
            }
            // let controller = new ScrollMagic.Controller();
            for (let i = 0; i < $section.length; i++) {
                let scene = new ScrollMagic.Scene({
                        triggerElement: $section[i],
                        triggerHook: 'onEnter',
                        reverse: false,
                        offset: 200
                    })
                    .addTo(controller);
                scene.on('enter', () => {
                    $section[i].classList.add(this.ANIMATION_CLASS);
                });
                scene.on('end', () => {
                    scene.destroy(true);
                });
            }
        }
    }

    new ScrollFade();

    const lineAnim = document.querySelector('#bgTxt');
    const scene1 = new ScrollMagic.Scene({
            triggerElement: "#about",
            triggerHook: 'onEnter',
            duration: 2000
        })
        .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
            var p = prog.progress; // 0～1の値が入ってきます
            lineAnim.style.left = `${30 - 100 * p}%`
        })
        .addTo(controller);
} else if (pathname === "/recruit/") {

    var controller = new ScrollMagic.Controller();

    // スクロールで回転率を上げる
    const mvScroll = document.querySelector('#mvScroll');
    const scene2 = new ScrollMagic.Scene({
            triggerElement: "#mv",
            triggerHook: 'onEnter',
            duration: 2000
        })
        .on("progress", function (prog01) { // 使いたいシーンに対してprogressイベントを設定します
            var p01 = prog01.progress; // 0～1の値が入ってきます
            mvScroll.style.animationDuration = `${20 - 12 * p01}s`
        })
        .addTo(controller);

    //カレント表示
    // const aboutH = document.getElementById('about').clientHeight;
    const introH = document.getElementById('intro').clientHeight;
    const numberH = document.getElementById('number').clientHeight;
    const welfareH = document.getElementById('welfare').clientHeight;
    const appH = document.getElementById('app').clientHeight;

    // new ScrollMagic.Scene({
    //     triggerElement: "#about",
    //     triggerHook: 'onLeave',
    //     duration: aboutH
    // })
    // .setClassToggle("#nav01", "is-current") // add class toggle
    // .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: "#intro",
        triggerHook: 'onLeave',
        duration: introH
    })
    .setClassToggle("#nav02", "is-current") // add class toggle
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: "#number",
        triggerHook: 'onLeave',
        duration: numberH
    })
    .setClassToggle("#nav03", "is-current") // add class toggle
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: "#welfare",
        triggerHook: 'onLeave',
        duration: welfareH
    })
    .setClassToggle("#nav04", "is-current") // add class toggle
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: "#app",
        triggerHook: 'onLeave',
        duration: appH
    })
    .setClassToggle("#nav05", "is-current") // add class toggle
    .addTo(controller);

    //スクロールアニメーション
    // let controller = new ScrollMagic.Controller();
    class ScrollFade {
        constructor() {
            this.ANIMATION_CLASS = 'is-fire';

            let $section = document.querySelectorAll('.js-scroll:not(.is-fire)');
            if ($section.length === null) {
                return;
            }
            // let controller = new ScrollMagic.Controller();
            for (let i = 0; i < $section.length; i++) {
                let scene = new ScrollMagic.Scene({
                        triggerElement: $section[i],
                        triggerHook: 'onEnter',
                        reverse: false,
                        offset: 100
                    })
                    .addTo(controller);
                scene.on('enter', () => {
                    $section[i].classList.add(this.ANIMATION_CLASS);
                });
                scene.on('end', () => {
                    scene.destroy(true);
                });
            }
        }
    }

    new ScrollFade();
}
